import { Component, Input, EventEmitter, OnInit, Output, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';

interface RecurringShift {
  Date: string;
  'Start Time': string;
  'End Time': string;
  'Unpaid Break' : string;
  'Transit Allowance' : string;
}

@Component({
  selector: 'app-edit-recurring-shift-list',
  templateUrl: './edit-recurring-shift-list.component.html',
  styleUrls: ['./edit-recurring-shift-list.component.scss'],
})
export class EditRecurringShiftListComponent implements OnInit, OnChanges{
  @Input() data: RecurringShift[] = [];
  @Input() config: string[] = [];
  @Input() formGroup;
  @Input() formGroupName?:string  = "recurringShifts";
  @Input() confirmationView;
  @Input() showEditIcon?: Boolean = true
  @Input() showRequiredAsterisk?: Boolean = false;
  @Input() companyType?: string;
  @Input() settings?: any;
  @Input() currentView?: string;
  @Output() onToggleCheckBox = new EventEmitter<{ checked: boolean; index: number }>();
  @Output() onToggleAllCheckBoxes = new EventEmitter<{ checked: boolean; index: number }>();

  checkBoxOptions = [{ 
    label: ""
  }]

  constructor(  private changeDetectorRef: ChangeDetectorRef ) {}

  ngOnInit(){
  }

  getControl(index: number){
    return this.formGroup.get(this.formGroupName).controls[index]
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.changeDetectorRef.detectChanges();
  }

  toggleCheckBox(value: boolean, index: number) {
    this.onToggleCheckBox.emit({ checked: value, index });
  }

  toggleAllCheckBoxes(value: boolean, index: number) {
    this.onToggleAllCheckBoxes.emit({ checked: value, index });
  }
 
}

